<div class="page">
  <section class="max-w-screen-2xl mx-auto min-h-screen px-4 py-4 md:py-16">
    <h1 class="text-6xl lg:text-[6.625rem] font-black uppercase">Locations</h1>

    @if (locations(); as locations) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-8">
      @for (location of locations; track location.id) {
      <a [routerLink]="['/locations', location.slug]"
        class="block rounded-xl border-2 border-white/20 p-6 hover:bg-white/5 transition-colors">
        <h2 class="text-2xl font-bold uppercase">{{ location.name }}</h2>
        @if (location.description) {
        <p class="mt-2 text-white/70">{{ location.description }}</p>
        }
      </a>
      }
    </div>
    }
  </section>
</div>
